import React from 'react';
import { ShieldCheck, Eye, HandCoins } from 'lucide-react';
import useReveal from '../hooks/useReveal';
import { SectionLabel } from '../components/shared';

const values = [
  { icon: ShieldCheck, title: 'Independent', body: 'We are not affiliated with Emirates airline or any UAE government body. “Emirates” on this site means the country — the United Arab Emirates.' },
  { icon: Eye, title: 'Transparent', body: 'Every sponsored or affiliate link is clearly marked. We only recommend places and services we’d genuinely use ourselves.' },
  { icon: HandCoins, title: 'Reader-first', body: 'Commissions never change our rankings. If something isn’t worth your money, we say so — that’s the whole point of an independent guide.' },
];

const About = () => {
  useReveal([]);
  return (
    <div className="bg-[#F6F1E3]">
      <section className="bg-[#1B1D21]">
        <div className="max-w-3xl mx-auto px-5 py-20 text-center">
          <span className="text-[12px] font-semibold tracking-[0.18em] uppercase text-[#CBA344]">About &amp; Disclaimer</span>
          <h1 className="mt-4 font-display text-[40px] sm:text-[50px] leading-[1.08] font-semibold text-white">
            An honest, independent UAE guide
          </h1>
          <p className="mt-5 text-[19px] leading-relaxed text-[#c3d1de]">
            Written for Australian visitors and future expats — kept current, fact-checked
            against official sources, and always clear about how we make money.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-5 py-16">
        <div className="grid md:grid-cols-3 gap-6">
          {values.map((v) => (
            <div key={v.title} className="reveal lift bg-white rounded-2xl border border-[#E6D7A2] p-7 shadow-[0_18px_40px_-28px_rgba(27,29,33,0.45)]">
              <span className="flex items-center justify-center w-12 h-12 rounded-xl sunset-gradient text-white">
                <v.icon className="w-6 h-6" />
              </span>
              <h3 className="mt-4 font-display text-[22px] font-semibold text-[#1B1D21]">{v.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-[#4B4F58]">{v.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 pb-20 space-y-10">
        <div className="reveal">
          <SectionLabel>Disclaimer</SectionLabel>
          <h2 className="mt-3 font-display text-[28px] font-semibold text-[#1B1D21]">Not affiliated with Emirates airline</h2>
          <p className="mt-3 text-[17px] leading-relaxed text-[#3a4f63]">
            This is an independent travel and relocation resource about the United Arab
            Emirates — the country made up of seven emirates. We are not connected to,
            endorsed by, or representing Emirates airline, any hotel chain, or any
            government authority. Entry rules and travel advice change; always confirm the
            latest details with official UAE government sources before you travel.
          </p>
        </div>
        <div className="reveal">
          <SectionLabel>Affiliate Disclosure</SectionLabel>
          <h2 className="mt-3 font-display text-[28px] font-semibold text-[#1B1D21]">How we make money</h2>
          <p className="mt-3 text-[17px] leading-relaxed text-[#3a4f63]">
            Some links on this site — particularly to hotels and travel insurance — are
            affiliate links. If you book through them, we may earn a small commission at no
            extra cost to you. These commissions help keep the guide free and independent.
            They never influence which places we recommend or how we rank them.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
